<template>
    <div class="author-popup">
        <div class="author-popup-row text-right mt--2">
            <img class="author-popup-close" src="@/assets/hometeacher/images/close.png" @click="close">
        </div>
        <div class="author-popup-row">
            <div class="author-popup-params">
                <div class="author-popup-name">{{author.author}}</div>
                <div class="author-popup-param" v-if="author.education">
                    <div class="author-popup-label" v-if="author.education">{{ $t('education') }}:</div>
                    <div class="author-popup-value">{{author.education}}</div>
                </div>
                <div class="author-popup-param" v-if="author.degree">
                    <div class="author-popup-label-inline">{{ $t('degree') }}:</div>
                    <div class="author-popup-value-inline">{{author.degree}}</div>
                </div>
                <div class="author-popup-param" v-if="author.experience">
                    <div class="author-popup-label-inline" v-if="author.experience">{{ $t('experience') }}:</div>
                    <div class="author-popup-value-inline">{{author.experience}}</div>
                </div>
            </div>
            <div class="author-popup-photo">
                <img v-if="author.photo" :src="`${author.photo}`" :alt="author.author">
            </div>
        </div>
        <div class="author-popup-row pt-1">
            <div class="author-popup-devider"></div>
        </div>
        <div class="author-popup-row author-popup-description">{{ author.description }}</div>
        <div class="author-popup-row" v-if="author.video">
            <video :src="`${author.video}`" style="max-width:99%;"
                   controls="controls"></video>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AuthorPopup",
        props: {
            author: Object,
        },

        methods: {
            close() {
                this.$emit('close')
            },
        }
    }
</script>

<style>
    .author-popup-name {
        font-family: "Manrope Bold";
        font-size: 24px;
        color: #231c37;
        margin-bottom: 15px;
    }

    .author-popup-label, .author-popup-label-inline {
        font-family: "Manrope Bold";
        color: #231c37;
        font-size: 14px;
    }


    .author-popup-value, .author-popup-value-inline {
        color: #231c37;
        font-size: 14px;
        line-height: 15px;
    }

    .author-popup-label-inline, .author-popup-value-inline {
        display: inline-block;
    }

    .author-popup {
        z-index: 1;
        position: relative;
        background: #e6eff2;
        padding: 30px;
        border-radius: 7px;
        margin-top: 30px;
        box-shadow: 1px 2px 7px 1px rgba(40, 40, 40, 0.15);
        max-width: 100%;
        width: 540px;
    }

    .author-popup-photo img {
        border-radius: 50%;
        box-shadow: 1px 2px 7px 1px rgba(40, 40, 40, 0.5);
        margin-bottom: 15px;
        width: 160px !important;
        height: 160px !important;
        object-fit: cover;
        float: none !important;
    }

    .author-popup-name, .author-popup-photo {
        display: inline-block;
    }

    .author-popup-params {
        width: 59%;
        float: left;
    }

    .author-popup-photo {
        text-align: right;
        width: 39%;
    }

    .author-popup-param {
        margin-bottom: 15px;
    }

    .author-popup-row {
        clear: both;
    }

    .author-popup-label-inline {
        margin-right: 5px;
    }

    .author-popup-label {
        margin-bottom: 5px;
    }

    .author-popup-close {
        cursor: pointer;
    }

    .author-popup-devider {
        width: 100%;
        height: 1px;
        background-color: #c4d4da;
        margin-bottom: 15px;
    }

    .author-popup-description {
        color: #4f4d5c;
        font-size: 16px;
        line-height: 18px;
        white-space: pre-line;
        margin-bottom: 30px;
    }
</style>
